export default __webpack_public_path__ + "static/media/road-company-img.0ce0dd34.jpg";